// Pure, framework-free helpers for the v2 role gating the SPA does (design §3).
// Kept out of auth-context so they can be unit-tested without React or the
// Firebase/API plumbing the provider pulls in.

export type WardRole = "member" | "admin";

export interface WardMembership {
  wardId: string;
  role: WardRole;
}

/** Whether the user administers this specific ward. */
export function isWardAdmin(wards: readonly WardMembership[], wardId: string): boolean {
  return wards.some((w) => w.wardId === wardId && w.role === "admin");
}

/**
 * Whether the user should see any admin UI at all: a global super-admin, or an
 * admin of at least one ward. Members (and signed-out users) get nothing.
 */
export function hasAdminAccess(isSuperAdmin: boolean, wards: readonly WardMembership[]): boolean {
  return isSuperAdmin || wards.some((w) => w.role === "admin");
}
